export const getFileExtensionFromFileName = (fileName) => {
  if (!fileName) return "";
  const lastDot = fileName.lastIndexOf(".");
  return lastDot !== -1 ? fileName.slice(lastDot + 1).toLowerCase() : "";
};
